const API_BASE = process.env.REACT_APP_SCENARIO_OS_API || '';
const BASE = `${API_BASE}/scenario-os/usage`;

function authHeaders(token) {
  return { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' };
}

function qs(params) {
  const sp = new URLSearchParams();
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') sp.set(k, String(v));
  });
  const s = sp.toString();
  return s ? `?${s}` : '';
}

export const usageAPI = {
  getReport: (token, params = {}) =>
    fetch(`${BASE}/report${qs(params)}`, { headers: authHeaders(token) }).then(async (r) => {
      if (!r.ok) throw new Error(`usage report ${r.status}`);
      return r.json();
    }),

  getTrends: (token, params = {}) =>
    fetch(`${BASE}/trends${qs(params)}`, { headers: authHeaders(token) }).then(async (r) => {
      if (!r.ok) throw new Error(`usage trends ${r.status}`);
      return r.json();
    }),

  getEvents: (token, params = {}) =>
    fetch(`${BASE}/events${qs(params)}`, { headers: authHeaders(token) }).then(async (r) => {
      if (!r.ok) throw new Error(`usage events ${r.status}`);
      return r.json();
    }),

  exportUrl: (token, params = {}) => {
    // Caller opens with Authorization via fetch blob download
    return `${BASE}/export${qs(params)}`;
  },

  downloadExport: async (token, params = {}) => {
    const resp = await fetch(`${BASE}/export${qs(params)}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!resp.ok) throw new Error(`usage export ${resp.status}`);
    const blob = await resp.blob();
    const fmt = (params.format || 'xlsx').toLowerCase();
    const filename = `teachiq_usage_report.${fmt === 'pdf' ? 'pdf' : 'xlsx'}`;
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  },
};
